import CustomBreadcrumbs from '@/commons/custom-breadcrumbs/CustomBreadcrumbs';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ListPage from '@/components/Table';
import { useQuery } from '@tanstack/react-query';
import { translates } from '@/utils';
import { TITLE } from '@utils/constants';
import { getReservations } from '@/services/reservations';
import { useReservationModal } from '@modules/reservations/modals/create';
import { Button } from '@PorkyCol/button';
import dayjs from 'dayjs';
import {Reservations, ReservationTable} from '@/services/reservations/types';
import React from "react";
import { TABLE_HEAD_RESERVATION } from '../utils/constants';
import { ListActionsReservation } from '../actions-list';

export default function ReservationList() {
  const navigate_reservations: any = {
    view: PATH_DASHBOARD.reservations.view,
    edit: PATH_DASHBOARD.reservations.edit,
  };
  const { modal, actionModal } = useReservationModal();
  const title = translates.reservations;
  const links = [
    { name: translates.dashboard, href: PATH_DASHBOARD.root },
    {
      name: translates.reservations,
      href: PATH_DASHBOARD.reservations.list,
    },
    { name: translates.list },
  ];

  const { isLoading, data = [] } = useQuery({
    queryKey: ['reservations'],
    queryFn: getReservations,
    select: (plans: Reservations[]) => plans?.map?.((plan) => {
        const { reserver } = plan;
        return {
          createAt: dayjs(plan.createAt).format('YYYY-MM-DD hh:mm A'),
          id: plan._id,
          name: reserver.name,
          email: reserver.email,
          phone: reserver.phone,
          document: reserver.document,
            message: plan.message,
          date: dayjs(plan.date).format('DD/MM/YYYY'),
          time: dayjs(plan.date).format('HH:mm'),
          attendees: plan.attendees,
          planObject: plan.plan,
          branch: plan.branch,
          plan: plan.plan?.name,
          status: plan.status,
        } as ReservationTable;
      }),
  });

  return (
    <>
      <Helmet>
          {TITLE}: {title} List
      </Helmet>
      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.list} ${title} `}
          links={links}
          action={[
            <Button
              size="sm"
              variant="outline"
              color="warning"
              key="indicator-new"
              onClick={() => actionModal()}
            >
              {`${translates.new} ${translates.reservations}`}
            </Button>,
          ]}
        />

        {modal}

        <ListPage<ReservationTable, number>
          data={data}
          navigateHandle={navigate_reservations}
          actions={ListActionsReservation}
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_RESERVATION}
        />
      </Container>
    </>
  );
}
